export function Logo({ size = "md", light = false }) {
  const dims = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className="flex items-center gap-2.5" data-testid="gepr-logo">
      <div className={`${dims} rounded-lg bg-sky-600 flex items-center justify-center shadow-sm`}>
        <svg viewBox="0 0 64 64" className="h-2/3 w-2/3">
          <path d="M20 46 V22 h16 a8 8 0 0 1 0 16 h-8 l12 8" fill="none" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="46" cy="20" r="5" fill="white" />
        </svg>
      </div>
      <div className="leading-none">
        <span className={`font-display font-extrabold tracking-tight ${text} ${light ? "text-white" : "text-slate-900"}`}>
          GEPR
        </span>
        <span className={`block text-[10px] font-medium ${light ? "text-slate-400" : "text-slate-500"}`}>
          Gestão p/ Refrigeração
        </span>
      </div>
    </div>
  );
}
